<template>
    <ul v-if="className == 'gnb'" :class="className">
        <template v-for="item in gnbs">
            <li v-if="!item.children" :key="item.title" :class="className + '__li'">
                <a v-if="item.isHref" :href="item.path" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </a>
                <router-link v-else :to="item.path" :class="className + '__link'">
                    <h2>{{ item.title }}</h2>
                </router-link>
            </li>

            <li v-else :key="item.title" :class="className + '__li'">
                <div v-if="isMobile" :class="className + '__link gnb__link--toggle'">
                    <h2>{{ item.title }}</h2>
                </div>
                <router-link v-else :to="item.path" :class="className + '__link gnb__link--toggle'">
                    <h2>{{ item.title }}</h2>
                </router-link>
                <ul :class="className + '__sub'">
                    <li v-for="child in item.children" :key="child.title">
                        <router-link :to="child.path">{{ child.title }}</router-link>
                    </li>
                </ul>
            </li>
        </template>
    </ul>
</template>

<script>
export default {
    props: {
        className: String,
        indexNum: String,
    },
    data: function () {
        return {
            window: {
                width: 0,
                height: 0,
            },
            gnbs: [
                {
                    title: "Info",
                    path: "/about",
                },
                {
                    title: "Recruit",
                    path: "/recruitments",
                },
                {
                    title: "Bridge",
                    path: "/programs",
                },
                {
                    title: "Agent",
                    path: "/service",
                },
                {
                    title: "Career",
                    path: "/lectures",
                },
            ],
        };
    },
    computed: {
        isDesktop: function () {
            return this.window.width >= 1200;
        },
        isMobile: function () {
            return this.window.width < 1200;
        },
    },
    created: function () {
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener("resize", this.handleResize);
    },
    mounted: function () {},
    methods: {
        handleResize: function () {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;
        },
    },
};
</script>